<template>
  <div style="min-height: 90.8vh">
    <div class="list" v-if="list.length > 0">
      <div
        class="list-item"
        v-for="item in list"
        :key="item.id"
        @click="handleItem(item)"
      >
        <div class="top">
          <van-tag plain type="primary" size="medium">{{
            item.auditStatus
          }}</van-tag>
          <span class="top-text"
            >{{ item.resttime }} {{ item.startTime }} - {{ item.endTime }}</span
          >
        </div>
        <div class="content">
          <div class="avatar">
            <img :src="item.photo" alt="" />
          </div>
          <div class="info">
            <div class="info-1">
              <div>{{ item.name }} {{ item.phone }}</div>
              <!-- <div
                class="btn"
                @click.stop="handleAuditBtn(item)"
                v-if="item.auditStatus == 0"
              >
                审批
              </div> -->
            </div>
            <!-- <div class="info-2" v-if="item.affiliatedUnit">
              {{ item.affiliatedUnit }}
            </div> -->
          </div>
        </div>
        <div class="count" v-if="item.otherList && item.otherList.length > 0">
          共计{{ item.otherList && item.otherList.length + 1 }}人：<span
            class=""
            v-for="(v, index) in item.otherList"
            >{{ v
            }}<span v-if="index !== item.otherList.length - 1"> / </span></span
          >
        </div>
        <div class="count" v-if="item.remark">备注：{{ item.remark }}</div>
        <div class="count" v-if="item.child">
          被接送人：
          <span v-for="v in item.child">{{ v }}</span>
        </div>
      </div>
    </div>

    <div class="personnel" v-if="ListData.length">
      <div class="cardBox">
        <div class="card" v-for="item in ListData">
          <div class="card-top">
            <div class="childState">
              <el-checkbox
                v-model="item.state"
                v-if="item.children.auditStatus == 0"
                @change="SelectChange(item)"
              />
              <div v-else style="width: 0.875rem; height: 0.875rem"></div>
            </div>
            <div class="childAvatar">
              <el-image
                style="width: 10vw; height: 10vw; border-radius: 10vw"
                :src="item.children.avatar"
                :preview-src-list="[item.children.avatar]"
              />
            </div>
            <div class="childMsg">
              {{ item.children.name }}{{item.children.className ? ' - ' + item.children.className : ''}}（{{ ['','自行上放学','家长接送','小饭桌接送'][item.children.dismissalType]}}）
            </div>
          </div>
          <div class="card-center">
            <div
              class="parItem"
              v-for="parItem in item.parents"
              v-show="parItem.auditStatus != 2"
            >
              <div class="parentState">
                <el-checkbox
                  v-model="parItem.state"
                  v-if="parItem.auditStatus == 0"
                />
                <div v-else style="width: 0.875rem; height: 0.875rem"></div>
              </div>
              <div class="parentAvatar">
                <el-image
                  style="width: 8vw; height: 8vw; border-radius: 10vw"
                  :src="parItem.avatar"
                  :preview-src-list="[parItem.avatar]"
                />
              </div>
              <div class="parentName">
                <span
                  v-if="parItem.operationType == 2"
                  style="color: rgb(253, 124, 148)"
                  >申请删除：</span
                >
                {{ parItem.name }}
              </div>
              <div class="parentTel">{{ parItem.tel }}</div>
            </div>
          </div>
          <div class="card-bottom">
            <div class="applyDate">申请时间：{{ item.date | date }}</div>
            <div class="Btn">
              <button class="rejectBtn" @click="showHiddenBox(item)">
                <span>驳回</span>
              </button>
              <button class="resolveBtn" @click="resolve(item)">
                <span>通过</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <van-dialog
        v-model="show"
        title=""
        show-cancel-button
        confirmButtonColor="rgb(107, 178, 250)"
        @confirm="reject()"
        @close="clearReject()"
        @cancel="closeBox"
        :before-close="beforeClose"
      >
        <div class="hiddenBox">
          <p>请输入驳回原因</p>
          <textarea type="text" v-model="text" />
        </div>
      </van-dialog>
    </div>
    <div v-if="!list.length && !ListData.length">
      <van-empty description="暂无数据" />
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      list: [],
      leaveList: [],
      leaveOffList: [],
      approvalBadge: {
        visitor: null,
        leave: null,
        pickup: null,
      },
      text: "",
      show: false,
      selectData: {},
      closeState: true,
    };
  },
  props: ["ListData"],
  created() {
    this.getList();
  },
  filters: {
    date(date) {
      return moment(date).format("YYYY/MM/DD HH:mm");
    },
  },
  methods: {
    getList() {
      this.list = [];
      // console.log('123123213213123')
      Promise.all([
        this.getAuditList(),
        this.getApproveLeaveList(),
        this.getLeaveOffListAudit(),
        this.getPickupAuditList(),
      ]).then((res) => {
        res.forEach((item) => {
          item.forEach((v) => {
            // v.resttime = moment(v.visitorBeginTime).format('YYYY.MM.DD')
            // v.startTime = moment(v.visitorBeginTime).format('HH:mm')
            // v.endTime = moment(v.visitorEndTime).format('HH:mm')
            this.list.push(v);
          });
        });
      });
    },


    // 预约审批列表
    async getAuditList() {
      // 获取待审批的预约数据
      const { data, code, msg } = await this.$https.getAuditList({
        auditType: 0,
        userId: this.$store.state.userId,
      });
      console.log('获取审批列表',data, code, msg);
      if (code !== 200) {
        this.$toast(msg);
        return false;
      }
      // 处理data数组 , 将自己审批过的数据剔除



      
      return Promise.resolve(
        data.map((item) => ({
          id: item.id,
          resttime: moment(item.visitorStartTime).format("YYYY.MM.DD"),
          startTime: moment(item.visitorStartTime).format("HH:mm"),
          endTime: moment(item.visitorEndTime).format("HH:mm"),
          name: item.initiatorName,
          phone: item.initiatorPhone,
          photo: item.avatar,
          otherList: item.visitorName,
          auditStatus: "预约",
          // path: '/leavedetail',
        }))
      );
    },
    // 代接送审批列表
    async getPickupAuditList() {
      const { data, code } = await this.$https.pickupAuditList({
        pickUpState: 0,
        userId: this.$store.state.userId,
        schoolId: this.$store.state.schoolId,
      });
      if (code !== 200) {
        return false;
      }
      console.log(data);
      // this.badge.pickup = data.list.length
      return Promise.resolve(
        data
          ? data.map((item) => ({
              resttime: moment(item.pickBeginTime).format("YYYY.MM.DD"),
              startTime: moment(item.pickBeginTime).format("HH:mm"),
              endTime: moment(item.pickEndTime).format("HH:mm"),
              id: item.id,
              name: "代接送人:" + item.pickUpPerson,
              auditStatus: "代接送",
              photo: item.pickUpPhoto,
              child: item.studentName,
            }))
          : []
      );
    },
    // 请假审批列表
    async getApproveLeaveList() {
      const { data, code } = await this.$https.getApproveLeaveList({
        leaveState: 0,
        userId: this.$store.state.userId,
        schoolId: this.$store.state.schoolId,
      });
      if (code !== 200) {
        return false;
      }
      this.leaveList = data.list;
      // this.badge.leave = data.list.length

      return Promise.resolve(
        data.list.map((item) => ({
          resttime: moment(item.leaveBeginTime).format("YYYY.MM.DD"),
          startTime: moment(item.leaveBeginTime).format("HH:mm"),
          endTime: moment(item.leaveEndTime).format("HH:mm"),
          id: item.id,
          name: item.leaveName,
          phone: item.leaveType,
          photo: item.userPhoto,
          remark: item.remark,
          auditStatus: "请假",
          photo: item.showAvatar,

          // otherList: item.visitorName,
        }))
      );
    },
    // 获取销假列表
    async getLeaveOffListAudit() {
      const { data, code } = await this.$https.leaveOffListAudit({
        leaveState: 0,
        userId: this.$store.state.userId,
        schoolId: this.$store.state.schoolId,
      });
      if (code !== 200) {
        return false;
      }
      this.leaveOffList = data.list;
      return Promise.resolve(
        data.list.map((item) => ({
          resttime: moment(item.leaveBeginTime).format("YYYY.MM.DD"),
          startTime: moment(item.leaveBeginTime).format("HH:mm"),
          endTime: moment(item.leaveEndTime).format("HH:mm"),
          id: item.id,
          name: item.leaveName,
          phone: item.leaveType,
          photo: item.userPhoto,
          remark: item.remark,
          auditStatus: "销假",
          photo: item.showAvatar,

          // otherList: item.visitorName,
        }))
      );
    },

    // 点击列表项跳转到详情页面
    handleItem(item) {
      // 跳转访客预约详情
      if (item.auditStatus == "预约") {
        this.$router.push({
          path: "/detailSub",
          query: { id: item.id, type: "approval" },
        });
      } else if (item.auditStatus == "请假") {
        console.log(this.getLeaveItem(item.id));
        const leaveItem = this.getLeaveItem(item.id);
        this.$router.push({
          path: "/leavedetail",
          query: { type: "au", ...leaveItem },
        });
      } else if (item.auditStatus == "代接送") {
        this.$router.push({
          path: "/pickupDetail",
          query: { id: item.id, type: "au" },
        });
      } else if (item.auditStatus == "销假") {
        // const leaveItem = this.getLeaveItem(item.id)
        const leaveItem = this.leaveOffList.find((i) => item.id == i.id);
        this.$router.push({
          path: "/leavedetail",
          query: { type: "au", ...leaveItem },
        });
      }
    },
    getLeaveItem(id) {
      return this.leaveList.find((item) => item.id == id);
    },
    showHiddenBox(data) {
      let obj = this.getSelectData(data);
      if (obj.children || obj.parents) {
        this.show = true;
        this.selectData = obj;
      } else {
        this.$toast("请选择人员后操作");
      }
    },
    resolve(data) {
      let obj = this.getSelectData(data);
      if (!obj.children && !obj.parents) {
        this.$toast("请选择人员后操作");
      } else {
        let parmas = this.getParmas(obj, 1);
        this.Submit(parmas);
      }
    },
    reject() {
      if (!this.text) {
        this.$toast("请输入驳回原因");
        this.closeState = false;
        return false;
      } else {
        this.closeState = true;
      }
      let parmas = this.getParmas(this.selectData, 2);
      this.Submit(parmas);
    },
    clearReject() {
      this.show = false;
      this.selectData = {};
      this.text = "";
    },
    getSelectData(data) {
      let obj = new Object();
      if (data.state) {
        obj.children = data.children;
      }
      obj.parents = data.parents.map((item) => {
        if (item.state) {
          return item;
        } else {
          return null;
        }
      });
      obj.parents = obj.parents.filter((item) => item);
      if (!obj.parents.length) {
        delete obj.parents;
      }
      return obj.children || obj.parents ? obj : "";
    },
    getParmas(data, type) {
      let arr = new Array();
      if (data.children) {
        arr.push(data.children.id);
      }
      if (data.parents) {
        data.parents.forEach((items) => {
          arr.push(items.id);
        });
      }
      return {
        auditStatus: type,
        remark: this.text,
        userId: this.$store.state.userId,
        ids: arr,
      };
    },
    async Submit(parmas) {
      const { code, data } = await this.$https.batchApproval(parmas);
      console.log(data, "data");
      if (!code == 200) {
        return false;
      } else {
        this.$toast("成功");
        location.reload();
      }
    },
    beforeClose(action, done) {
      if (!this.closeState) {
        done(false);
      } else {
        done();
      }
    },
    closeBox() {
      this.closeState = true;
    },
    SelectChange(data) {
      if (data && data.state) {
        data.parents.forEach((item) => {
          item.state = true;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.list {
  /* padding: 1.5rem 0; */
  margin: 1rem;
  .list-item {
    display: flex;
    flex-direction: column;
    background: #fff;
    margin-bottom: 0.63rem;
    border-radius: 0.75rem;
    position: relative;
    &::after,
    &::before {
      content: "";
      width: 1rem;
      height: 1rem;
      background: #f7f7fa;
      border-radius: 50%;
      position: absolute;
      top: 2.6rem;
    }
    &::after {
      right: -0.5rem;
    }
    &::before {
      left: -0.5rem;
    }
    .top {
      padding: 0.88rem 0;
      margin: 0 0.75rem;
      border-bottom: 1px dashed #d9dee9;
      font-size: 1rem;
      /* .status {
        background: rgba(52, 151, 253, 0.13);
        border-radius: 50%;
        color: #3497fd;
        display: inline-block;
        width: 1.5rem;
        height: 1.5rem;
        text-align: center;
        line-height: 1.5rem;
        font-size: 0.75rem;
      } */
      .top-text {
        display: inline-block;
        vertical-align: middle;
        margin-left: 1.31rem;
        font-size: 0.88rem;
        color: #78849e;
      }
    }
    .content {
      margin: 0 0.75rem;
      padding: 0.81rem 0;
      display: flex;
      align-items: center;
      .avatar {
        width: 2.88rem;
        height: 2.88rem;
        margin-right: 0.81rem;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 50%;
        }
      }
      .info {
        flex: 1;
        color: #959dad;
        .info-1 {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 0.88rem;
          .btn {
            background: rgba(52, 151, 253, 0.13);
            color: #3497fd;
            width: 3.88rem;
            height: 1.56rem;
            border-radius: 2rem;
            text-align: center;
            line-height: 1.56rem;

            font-size: 0.81rem;
          }
        }
      }
    }
    .count {
      color: #959dad;
      margin: 0 0.75rem;
      font-size: 0.75rem;
      padding-bottom: 0.81rem;
    }
  }
}
.personnel {
  .cardBox {
    font-family: "Microsoft YaHei";
    margin-top: 3vw;
    padding-bottom: 10vw;
    .card {
      margin-bottom: 3vw;
      background: white;
      width: 90%;
      margin-left: 5%;
      border-radius: 3vw;
      padding-top: 2vw;
      .card-top {
        display: flex;
        justify-content: left;
        align-items: center;
        padding-left: 3vw;
        .childAvatar {
          margin-left: 3vw;
        }
        .childMsg {
          font-size: 4vw;
          transform: scale(0.9);
        }
      }
      .card-center {
        padding-bottom: 2vw;
        .parItem {
          display: flex;
          justify-content: left;
          align-items: center;
          padding-left: 12vw;
          .parentAvatar {
            margin-left: 3vw;
          }
          .parentName {
            transform: scale(0.8);
            font-size: 3.7vw;
            color: rgba(0, 0, 0, 0.6);
            width: 38vw;
          }
          .parentTel {
            position: absolute;
            right: 9vw;
            transform: scale(0.8);
            font-size: 3.7vw;
            color: rgba(0, 0, 0, 0.6);
          }
        }
      }
      .card-bottom {
        display: flex;
        justify-content: left;
        align-items: center;
        padding: 3vw 0;
        border-top: 1px solid rgba(0, 0, 0, 0.05);
        .applyDate {
          font-size: 3.5vw;
          transform: scale(0.8);
          color: rgba(0, 0, 0, 0.6);
        }
        .Btn {
          position: absolute;
          right: 7vw;
          span {
            font-size: 3.5vw;
            display: inline-block;
            transform: scale(0.8) translate(0, -5%);
            color: rgba(255, 255, 255, 0.8);
          }
          button {
            width: 16vw;
            padding: 0;
            border-radius: 5vw;
            border: none;
            margin: 0 1vw;
          }
          .rejectBtn {
            background: rgb(230, 123, 41);
          }
          .resolveBtn {
            background: rgb(26, 136, 249);
          }
        }
      }
    }
  }
}
button:active {
  opacity: 0.7;
}
.hiddenBox {
  font-family: "Microsoft YaHei";
  width: 100%;
  height: 50vw;
  padding-bottom: 5vw;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  p {
    margin: 0;
    padding: 4vw;
    text-align: center;
  }
  textarea {
    box-sizing: border-box;
    width: 80%;
    margin-left: 10%;
    height: 72%;
    border: none;
    outline: none;
    background: rgb(246, 246, 246);
    padding: 3vw;
    border-radius: 2vw;
    resize: none;
  }
}
// ::v-deep .van-dialog {
//   top: 180vh;
// }
</style>
